import { getPlansByCourseIdFetcher } from '../../fetcher/ambassdor'
import { useQuery, type QueryObserverResult } from '@tanstack/react-query'

interface UseGetCoursePlansProps {
  courseId?: string
  enabled?: boolean
}

interface CoursePlan {
  planId: string
  title: string
  price: number
  total: number
  discount: number
  duration?: number
  durationType?: string
  description?: string
  isRecommended: boolean
  isPlanPurchased: boolean
  courseId: string
}

interface GetCoursePlansResponse {
  data: CoursePlan[]
}

interface UseGetCoursePlansReturn {
  data: CoursePlan[]
  isLoading: boolean
  error: Error | null
  refetch: () => Promise<QueryObserverResult<GetCoursePlansResponse, Error>>
}

const useGetCoursePlans = ({
  courseId,
  enabled = true,
}: UseGetCoursePlansProps): UseGetCoursePlansReturn => {
  const { data, isLoading, error, refetch } = useQuery<
    GetCoursePlansResponse,
    Error
  >({
    queryKey: ['get-course-plans', { courseId }],
    queryFn: getPlansByCourseIdFetcher,
    retry: 1, // Retry once on failure
    enabled: !!courseId && enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
  })
  return {
    data: data?.data || [],
    isLoading,
    error,
    refetch,
  }
}

export default useGetCoursePlans
